export interface ITimezone {
  displayText: string;
  windowsTimezoneId: string;
  isDefault: boolean;
}

export const TIMEZONES: ITimezone[] = [
  {
    displayText: 'GMT Standard Time (London)',
    windowsTimezoneId: 'GMT Standard Time',
    isDefault: true,
  },
  {
    displayText: 'Eastern Standard Time (New York) (GMT-05:00)',
    windowsTimezoneId: 'Eastern Standard Time',
    isDefault: false,
  },
  {
    displayText: 'Singapore Standard Time (GMT+08:00)',
    windowsTimezoneId: 'Singapore Standard Time',
    isDefault: false,
  },
  {
    displayText: 'W. Europe Standard Time (Berlin) (GMT+01:00)',
    windowsTimezoneId: 'W. Europe Standard Time',
    isDefault: false,
  },
  {
    displayText: 'South Africa Standard Time (South Africa) (UTC+02:00)',
    windowsTimezoneId: 'South Africa Standard Time',
    isDefault: false,
  },
];
